export default "__VITE_ASSET__aP1X80qV__"